import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './App.css';
import { AppRouter } from './navigations';
import { useState, useLayoutEffect, useRef } from 'react';
import { SessionExpiredModal } from './components/SessionExpiredModal';
import { Toaster } from './components/ui/toaster';
const queryClient = new QueryClient();

function App() {

  const targetRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    if (!targetRef.current) return;

    const resizeObserver = new ResizeObserver(entries => {
      // This is the problematic part. We are always setting state.
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        // This setState triggers a re-render, which might cause another resize.
        setDimensions({ width, height });
      }
    });

    resizeObserver.observe(targetRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <div ref={targetRef} style={{ padding: "5px" }}>
        <AppRouter />
        <SessionExpiredModal />
      </div>
    </QueryClientProvider>
  );
}

export default App;
